'use client';
import styled from 'styled-components';
import Drawer from 'antd/es/drawer';

export const StyledDrawer = styled(Drawer)`
  &&& {
    .setur-drawer-header {
      display: none;
    }

    .setur-drawer-body {
      padding: 16px 0px 0px 0px;
      background-color: ${({ theme }) => theme.palette.grey1100};
    }

    .setur-drawer-footer {
      padding: 16px 24px;
      border-top: 1px solid ${({ theme }) => theme.palette.whiteAlpha200};
      background-color: ${({ theme }) => theme.palette.grey1100};
    }
  }
`;
